import { useEffect, useRef } from 'react';

/**
 * Reports when a popover's content is shown and hidden.
 *
 * UIPopover mounts its content only while open and overrides the trigger's
 * onClick, so open/close detection has to come from the content's lifecycle
 * rather than from the trigger. Render this anywhere inside the popover.
 */
export function UIPopoverMountSensor(props: {
    onMount: () => void;
    onUnmount: () => void;
}): null {
    const { onMount, onUnmount } = props;

    const onMountRef = useRef(onMount);
    onMountRef.current = onMount;
    const onUnmountRef = useRef(onUnmount);
    onUnmountRef.current = onUnmount;

    useEffect(() => {
        onMountRef.current();
        return () => {
            onUnmountRef.current();
        };
    }, []);

    return null;
}
